import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { getLastCorrelationId } from '@platform/client';
import { useCallback } from 'react';

import { telemetryStarted } from './telemetry';

/**
 * Fires the reporting pipeline on demand. A reporter that has silently stopped
 * delivering looks exactly like a system with no errors, so there has to be a way to
 * ask it. Development only: the deployed admin has one operator who should never meet
 * a button labelled "throw".
 *
 * The throw is deliberately unwrapped. React does not catch errors raised in an event
 * handler, so it leaves the app and is picked up by Sentry's global handler — the
 * path a real uncaught bug takes.
 */
export function TelemetryProbe() {
  const crash = useCallback(() => {
    throw new Error('ADMIN-08 deliberate test error');
  }, []);

  if (!import.meta.env.DEV) return null;

  return (
    <Stack spacing={1} sx={{ mt: 4, alignItems: 'flex-start' }}>
      {telemetryStarted ? (
        <Typography variant="body2" color="text.secondary">
          Reporting as release {__ADMIN_RELEASE__}. The next event carries
          correlation id {getLastCorrelationId()}.
        </Typography>
      ) : (
        <Alert severity="warning">
          VITE_SENTRY_DSN is not set, so nothing is being reported. This button
          will still throw.
        </Alert>
      )}
      <Button variant="outlined" color="error" onClick={crash} size="small">
        Throw a test error
      </Button>
    </Stack>
  );
}
